const STORAGE_KEY = 'demohub_social';

export const USERS = {
  user1: { id: 'user1', name: 'You', handle: '@you', avatar: '🧑‍💻', verified: false },
  user2: { id: 'user2', name: 'Sarah Chen', handle: '@sarahdesigns', avatar: '👩‍🎨', verified: true },
  user3: { id: 'user3', name: 'Alex Rivera', handle: '@alexcodes', avatar: '👨‍💻', verified: true },
  user4: { id: 'user4', name: 'Maya Patel', handle: '@mayapm', avatar: '👩‍💼', verified: true },
  user5: { id: 'user5', name: 'James Wilson', handle: '@jameswdata', avatar: '🧑‍🔬', verified: false },
  user6: { id: 'user6', name: 'Emma Thompson', handle: '@emmatech', avatar: '👩‍🏫', verified: true },
  user7: { id: 'user7', name: 'David Kim', handle: '@davidops', avatar: '👨‍🎤', verified: false },
  user8: { id: 'user8', name: 'Lisa Wang', handle: '@lisabuilds', avatar: '👩‍🔧', verified: true },
};

export const STORIES = [
  { userId: 'user2', seen: false },
  { userId: 'user3', seen: false },
  { userId: 'user6', seen: true },
  { userId: 'user8', seen: false },
  { userId: 'user4', seen: true },
  { userId: 'user7', seen: true },
  { userId: 'user5', seen: false },
];

const now = Date.now();

const defaultPosts = [
  {
    id: 'p1', userId: 'user2', timestamp: now - 1800000,
    text: "Just finished designing this dashboard UI. What do you think? 🎨✨\n\nSpent the whole weekend perfecting the micro-interactions. Sometimes the details make all the difference!",
    image: '🖼️', imageLabel: 'Dashboard Design Preview',
    likes: 234, comments: 18, shares: 12, bookmarked: false, liked: false,
  },
  {
    id: 'p2', userId: 'user3', timestamp: now - 3600000,
    text: "TIL: You can use `Promise.allSettled()` instead of `Promise.all()` when you don't want a single rejection to fail everything. Game changer for handling multiple API calls! 💡\n\n#javascript #webdev #coding",
    likes: 567, comments: 43, shares: 89, bookmarked: false, liked: false,
  },
  {
    id: 'p3', userId: 'user4', timestamp: now - 7200000,
    text: "Product launch day! 🚀\n\nAfter 6 months of hard work, our team shipped the new analytics platform. So proud of everyone involved.\n\nKey metrics from day 1:\n→ 10,000+ signups\n→ 99.9% uptime\n→ 4.8 avg rating\n\nThis is just the beginning!",
    likes: 892, comments: 67, shares: 134, bookmarked: false, liked: false,
  },
  {
    id: 'p4', userId: 'user6', timestamp: now - 14400000,
    text: "Hot take: The best code is the code you don't write. 🔥\n\nBefore adding a new library or building a new abstraction, ask yourself:\n\n1. Can the existing code handle this?\n2. Is the complexity worth it?\n3. Will my team understand this in 6 months?\n\nSimplicity wins. Every. Single. Time.",
    likes: 1243, comments: 89, shares: 201, bookmarked: false, liked: false,
  },
  {
    id: 'p5', userId: 'user5', timestamp: now - 28800000,
    text: "Ran my first ML model on the new dataset and the results are incredible 📊\n\nAccuracy went from 87.2% → 94.7% just by cleaning the input data properly. Data quality > model complexity.\n\n#machinelearning #datascience #ai",
    likes: 456, comments: 32, shares: 56, bookmarked: false, liked: false,
  },
  {
    id: 'p6', userId: 'user8', timestamp: now - 43200000,
    text: "Open source contribution tip:\n\nDon't start with code. Start by:\n📖 Reading the docs\n🐛 Triaging issues\n💬 Answering questions\n📝 Improving documentation\n\nMaintainers notice and appreciate this way more than random PRs. Build trust first!",
    likes: 789, comments: 54, shares: 167, bookmarked: false, liked: false,
  },
  {
    id: 'p7', userId: 'user7', timestamp: now - 57600000,
    text: "Just migrated our entire infrastructure to Kubernetes. Zero downtime. 😎\n\nThe secret? Canary deployments + feature flags + a LOT of testing.\n\nDeployment time went from 45 minutes to 3 minutes. Worth every hour of work.",
    likes: 345, comments: 28, shares: 45, bookmarked: false, liked: false,
  },
  {
    id: 'p8', userId: 'user2', timestamp: now - 86400000,
    text: "Design systems aren't about making everything look the same. They're about making everything feel cohesive while giving teams the freedom to innovate within constraints.\n\nConsistency ≠ Uniformity",
    likes: 678, comments: 41, shares: 93, bookmarked: false, liked: false,
  },
  {
    id: 'p9', userId: 'user3', timestamp: now - 100800000,
    text: "Code review checklist I follow:\n\n✅ Does it solve the actual problem?\n✅ Is there a simpler approach?\n✅ Are edge cases handled?\n✅ Are there tests?\n✅ Is it readable without comments?\n✅ Would I be confident deploying this on Friday?\n\nThat last one catches a lot 😄",
    likes: 1567, comments: 112, shares: 289, bookmarked: false, liked: false,
  },
  {
    id: 'p10', userId: 'user4', timestamp: now - 129600000,
    text: "Hiring managers: stop requiring 5 years of experience in a 3-year-old technology.\n\nInstead, look for:\n🧠 Problem-solving ability\n📚 Willingness to learn\n🤝 Communication skills\n💪 Grit and determination\n\nSkills can be taught. Mindset is everything.",
    likes: 2341, comments: 198, shares: 456, bookmarked: false, liked: false,
  },
];

const SAMPLE_COMMENTS = {
  p1: [
    { id: 'c1', userId: 'user3', text: "This is stunning! Love the glassmorphism effect 🔥", timestamp: now - 1600000, likes: 12 },
    { id: 'c2', userId: 'user6', text: "Really clean layout. What tool did you use?", timestamp: now - 1400000, likes: 5 },
  ],
  p2: [
    { id: 'c3', userId: 'user5', text: "This saved me so many headaches last week!", timestamp: now - 3400000, likes: 8 },
  ],
  p3: [
    { id: 'c4', userId: 'user2', text: "Congratulations! 🎉 The UI looks amazing", timestamp: now - 7000000, likes: 15 },
    { id: 'c5', userId: 'user3', text: "Those are incredible day-1 numbers!", timestamp: now - 6800000, likes: 9 },
    { id: 'c6', userId: 'user6', text: "Well deserved. The team crushed it! 💪", timestamp: now - 6500000, likes: 7 },
  ],
};

export function loadSocialState() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) { /* ignore */ }
  return { posts: defaultPosts, comments: SAMPLE_COMMENTS };
}

export function saveSocialState(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) { /* ignore */ }
}

export function formatRelativeTime(timestamp) {
  const diff = Date.now() - timestamp;
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  return new Date(timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatNumber(num) {
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return num.toString();
}
